import React, { useRef } from "react";
import { motion, useReducedMotion } from "framer-motion";

import { Z_INDEX } from "../../core/utils/zIndexScale";
import { clampDurationSec } from "./websiteAnimations";

const LightRevealOverlay = ({ isActive, durationSec, onDone }) => {
  const reduceMotion = useReducedMotion();
  const doneRef = useRef(false);

  if (!isActive) return null;

  const d = clampDurationSec(durationSec, 2.0);
  const curtainSec = reduceMotion ? Math.min(0.6, d * 0.5) : Math.min(2.0, d);
  const flashSec = reduceMotion ? Math.min(0.35, d * 0.3) : Math.min(0.9, d * 0.45);

  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 pointer-events-none overflow-hidden"
      style={{ zIndex: Z_INDEX.POPOVER - 1 }}
    >
      {/* Ambient background */}
      <motion.div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 50% 45%, rgba(59,130,246,0.22) 0%, rgba(17,24,39,0.82) 60%, rgba(0,0,0,0.92) 100%)",
        }}
        initial={{ opacity: 0.6 }}
        animate={{ opacity: 0 }}
        transition={{ duration: curtainSec, ease: "easeOut" }}
      />

      {/* Cinematic curtain (blur + dim) */}
      <motion.div
        className="absolute inset-0"
        style={{
          background: "rgba(0,0,0,0.42)",
          backdropFilter: "blur(12px) saturate(1.1)",
          WebkitBackdropFilter: "blur(12px) saturate(1.1)",
        }}
        initial={{ opacity: 0.92 }}
        animate={{ opacity: 0 }}
        transition={{ duration: curtainSec, ease: "easeOut" }}
        onAnimationComplete={() => {
          if (doneRef.current) return;
          doneRef.current = true;
          try {
            onDone?.();
          } catch (_) {
            // Best-effort only.
          }
        }}
      />

      {/* Light flash */}
      <motion.div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 50% 45%, rgba(255,255,255,0.22) 0%, rgba(191,219,254,0.20) 28%, rgba(59,130,246,0) 64%)",
          mixBlendMode: "screen",
        }}
        initial={{ opacity: 0, scale: 0.99 }}
        animate={{ opacity: [0, 1, 0], scale: [0.99, 1.02, 1.0] }}
        transition={{ duration: flashSec, ease: "easeInOut", times: [0, 0.3, 1] }}
      />
    </div>
  );
};

export default LightRevealOverlay;

